import { SuperMove, CardState, RecordState } from '../../redux/types';

export function superMoveSelector(state: RecordState, index: number): SuperMove | false {
  const { superMove } = state.get('settings');
  if (!superMove) return false;
  if (superMove.state === CardState.slots && index === superMove.index) {
    return superMove;
  }

  return false;
}
